import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  section: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 2),
  },
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: 0,
  },
  sectionHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: theme.spacing(1, 0),
    width: '100%',
  },
}));

/** A titled section of the document summary drawer. */
export function Section({ children, headerChildren, headerId, title }: SectionProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.sectionHeader} id={headerId}>
        <Typography variant="h2">{title}</Typography>
        {headerChildren}
      </div>
      <div className={classes.sectionContent}>{children}</div>
    </div>
  );
}

interface SectionProps {
  children: React.ReactNode;
  title: string;
  headerChildren?: React.ReactNode;
  headerId?: string;
}
